<template>
  <div>
    <DisplayTable v-bind:data="home" v-bind:columns="homeColumns" v-bind:tableTitle="'Home'"></DisplayTable>
    <br />
    <v-progress-circular indeterminate v-if="loadingUsers"></v-progress-circular>
    <DisplayTable
      v-if="!loadingUsers"
      v-bind:data="users"
      v-bind:columns="userColumns"
      v-bind:routerLinkPath="'user'"
      v-bind:routerLinkKey="'userId'"
      v-bind:tableTitle="'Users'"
    ></DisplayTable>
    <br />
    <v-progress-circular indeterminate v-if="loadingDevices"></v-progress-circular>
    <DisplayTable
      v-if="!loadingDevices"
      v-bind:data="devices"
      v-bind:columns="deviceColumns"
      v-bind:routerLinkPath="'device'"
      v-bind:routerLinkKey="'deviceId'"
      v-bind:tableTitle="'Devices'"
    ></DisplayTable>
    <br />
    <router-link :to="'/'">Go back to search page</router-link>
  </div>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default
import DisplayTable from "@/views/DisplayTable"

export default {
  components: {
    DisplayTable
  },
  data() {
    return {
      homeId: "",
      users: [],
      userColumns: [],
      devices: [],
      deviceColumns: [],
      loadingUsers: false,
      loadingDevices: false,
      home: [],
      homeColumns: []
    }
  },
  async mounted() {
    middleware.run(this.$router)
    await this.init()
  },
  methods: {
    async init() {
      this.loadingUsers = true
      this.loadingDevices = true
      try {
        this.homeId = this.$route.params.id

        this.home = [{ homeId: this.homeId }]
        this.homeColumns = ["homeId"]

        var userResult = await restHelper.getUsersForHome(this.homeId)
        this.loadingUsers = false
        this.users = userResult.data.users
        this.userColumns = [
          "userId",
          "email",
          "firstName",
          "lastName",
          "isAdmin"
        ]

        var deviceResult = await restHelper.getDevicesForHome(this.homeId)
        this.loadingDevices = false
        this.devices = deviceResult.data.devices
        this.deviceColumns = ["deviceId", "homeId", "alias"]
      } catch (error) {}

      this.loadingUsers = false
      this.loadingDevices = false
    }
  }
}
</script>

